export type BootState = "loading" | "ready" | "failed";

export function resolveBootStateLabel(state: BootState): string {
  return state === "failed" ? "Tap to retry" : "GridFlow";
}
